
    // extracted by mini-css-extract-plugin
module.exports = {"testimonial":"zf80f9 z30325 z5b40d","footer":"z00c69 za3fbb","bio":"zed369 zb5d5a","image":"ze66dd zcfeb1","testimonials":"zbfd6a zfefbb ze7fe1","desktopTestimonials":"zd8ef2 zbfd6a zfefbb ze7fe1","prev":"z8ab2b","next":"zec518","text":"z686f8"};;
    module.exports = module.exports || {};
    module.exports.toString = function() {
      return JSON.stringify(module.exports)
    };
  